<div class="container">
  @if (isLoading) {
  <div class="loadingOverlay center-loader">
    <p-progressSpinner [style]="{height: '30px', width: '30px'}" strokeWidth="7"
      animationDuration="0.5s"></p-progressSpinner>
  </div>
  }

  <div class="content-wrapper">
    <div class="content neo-scrollbar">
      <div class="section">
        <div class="section-heading">
          App Integrations
        </div>
        <div class="section-subheading">
          Integrate popular collaboration tools for smooth meetings and efficient teamwork
        </div>

        <div class="providers-list">
          @for (provider of providers; track provider.key) {
          <div class="provider-card">
            <div class="provider-icon-wrapper">
              <i *ngIf="provider.key === 'default'" class="pi pi-video provider-icon-pi"></i>
              <img *ngIf="provider.key !== 'default'" [src]="getProviderIcon(provider.key)" [alt]="provider.name"
                class="provider-icon" />
            </div>

            <div class="provider-info">
              <div class="provider-name">{{ provider.name }}</div>
              <div class="provider-description">{{ getProviderDescription(provider.key) }}</div>
              <div class="provider-status" [class.connected]="provider.is_integrated"
                [class.not-connected]="!provider.is_integrated">
                <span class="status-dot"></span>
                {{ provider.is_integrated ? 'Connected' : 'Not Connected' }}
              </div>
              @if (!provider.is_integrated && provider.oauth_error) {
              <div class="oauth-error">
                <i class="pi pi-exclamation-triangle oauth-error-icon"></i>
                <span class="oauth-error-text">
                  <span class="oauth-error-prefix">Last attempt failed:</span>
                  {{ provider.oauth_error }}
                </span>
              </div>
              }
            </div>

            <div class="provider-actions">
              @if (provider.is_integrated && provider.key !== 'default') {
              <button pButton class="details-btn" (click)="onShowDetails(provider)">
                Details
              </button>
              <button pButton class="revoke-btn" (click)="onShowRevokeConfirm(provider)"
                *ngIf="userPrivileges.has('integration.update')">
                Revoke
              </button>
              } @else if (!provider.is_integrated) {
              <button pButton class="connect-btn" (click)="onConnect(provider)"
                *ngIf="userPrivileges.has('integration.update') && !provider.is_disabled">
                Connect
              </button>
              <button pButton class="connect-btn disabled-connect-btn" 
                *ngIf="userPrivileges.has('integration.update') && provider.is_disabled"
                [pTooltip]="getDisabledReason(provider)"
                tooltipPosition="top"
                [disabled]="true">
                Connect
              </button>
              }
            </div>
          </div>
          } @empty {
          @if (!isLoading) {
          <div class="empty-state">
            <p>No integrations available</p>
          </div>
          }
          }
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Details Dialog -->
<p-dialog [(visible)]="showDetailsDialog" [modal]="true" [closable]="true" [draggable]="false" [resizable]="false"
  [style]="{width: '480px'}" [showHeader]="false" (onHide)="closeDetailsDialog()">

  <div class="dialog-wrapper" *ngIf="selectedProvider">
    <div class="dialog-custom-header">
      <div class="dialog-header">
        <div class="dialog-provider-icon-wrapper">
          <img [src]="getProviderIcon(selectedProvider.key)" [alt]="selectedProvider.name"
            class="dialog-provider-icon" />
        </div>
        <div class="dialog-header-text">
          <span class="dialog-title">{{ selectedProvider.name }} Details</span>
          <div class="connection-status connected">
            <i class="pi pi-check-circle"></i>
            <span>Connected</span>
          </div>
        </div>
      </div>
      <button class="dialog-close-btn" (click)="closeDetailsDialog()">
        <i class="pi pi-times"></i>
      </button>
    </div>

    <div class="dialog-content">

      @if (isLoadingProfile) {
      <div class="profile-loading">
        <p-progressSpinner [style]="{height: '20px', width: '20px'}" strokeWidth="5"
          animationDuration="0.5s"></p-progressSpinner>
      </div>
      } @else if (providerProfile) {
      <div class="profile-details">
        <div class="profile-item">
          <div class="profile-icon-wrapper">
            <i class="pi pi-user"></i>
          </div>
          <div class="profile-text">
            <span class="profile-label">Connected user</span>
            <span class="profile-value">{{ providerProfile.display_name }}</span>
          </div>
        </div>
        <div class="profile-item">
          <div class="profile-icon-wrapper email-icon">
            <i class="pi pi-envelope"></i>
          </div>
          <div class="profile-text">
            <span class="profile-label">Email</span>
            <span class="profile-value">{{ providerProfile.email }}</span>
          </div>
        </div>
      </div>
      }
    </div>
  </div>
</p-dialog>

<!-- Revoke Confirmation Dialog -->
<p-dialog [(visible)]="showRevokeDialog" [modal]="true" [closable]="true" [draggable]="false" [resizable]="false"
  [style]="{width: '480px'}" [showHeader]="false">

  <div class="dialog-wrapper" *ngIf="selectedProvider">
    <div class="dialog-custom-header">
      <div class="dialog-header">
        <div class="dialog-provider-icon-wrapper">
          <img [src]="getProviderIcon(selectedProvider.key)" [alt]="selectedProvider.name"
            class="dialog-provider-icon" />
        </div>
        <div class="dialog-header-text">
          <span class="dialog-title">{{ selectedProvider.name }} Details</span>
          <div class="connection-status connected">
            <i class="pi pi-check-circle"></i>
            <span>Connected</span>
          </div>
        </div>
      </div>
      <button class="dialog-close-btn" (click)="onCancelRevoke()">
        <i class="pi pi-times"></i>
      </button>
    </div>

    <div class="dialog-content">

      @if (isLoadingProfile) {
      <div class="profile-loading">
        <p-progressSpinner [style]="{height: '20px', width: '20px'}" strokeWidth="5"
          animationDuration="0.5s"></p-progressSpinner>
      </div>
      } @else if (providerProfile) {
      <div class="profile-details">
        <div class="profile-item">
          <div class="profile-icon-wrapper">
            <i class="pi pi-user"></i>
          </div>
          <div class="profile-text">
            <span class="profile-label">Connected user</span>
            <span class="profile-value">{{ providerProfile.display_name }}</span>
          </div>
        </div>
        <div class="profile-item">
          <div class="profile-icon-wrapper email-icon">
            <i class="pi pi-envelope"></i>
          </div>
          <div class="profile-text">
            <span class="profile-label">Email</span>
            <span class="profile-value">{{ providerProfile.email }}</span>
          </div>
        </div>
      </div>
      }

      @if (selectedProvider.key === 'zoom') {
      <div class="revoke-implications">
        <div class="implications-header">
          <i class="pi pi-exclamation-triangle"></i>
          <span>Before you disconnect, please note:</span>
        </div>
        <ul class="implications-list">
          <li>
            <i class="pi pi-link"></i>
            <span>Your Zoom OAuth authorization will be revoked and NeoHire will no longer have access to your Zoom
              account.</span>
          </li>
          <li>
            <i class="pi pi-calendar-minus"></i>
            <span>Future scheduled interviews will no longer automatically generate Zoom meeting links. You will need to
              manually create and share meeting links.</span>
          </li>
          <li>
            <i class="pi pi-trash"></i>
            <span>All stored Zoom tokens and associated account data (display name, email) will be permanently deleted
              from NeoHire's system.</span>
          </li>
          <li>
            <i class="pi pi-history"></i>
            <span>Previously created Zoom meeting links for past interviews will remain unaffected, but NeoHire will no
              longer be able to manage or update them.</span>
          </li>
          <li>
            <i class="pi pi-refresh"></i>
            <span>You can reconnect Zoom at any time by clicking the "Connect" button, which will require you to
              re-authorize NeoHire with your Zoom account.</span>
          </li>
        </ul>
      </div>
      }

      <div class="disconnect-section">
        <button pButton class="disconnect-btn" (click)="onConfirmRevoke()" [loading]="isRevoking">
          Disconnect Integration
        </button>
        @if (selectedProvider.key !== 'zoom') {
        <p class="disconnect-note">Disconnecting will stop all synchronization with this account.</p>
        }
      </div>
    </div>
  </div>
</p-dialog>